import React from 'react';
import styles from './QuestionNumber.module.css';

export default function QuestionNumber({ className, questionNum }) {
	return (
		<div className={`${styles.questionNumber} ${className}`}><span>{questionNum}</span></div>
	);
}
